module.exports = __webpack_public_path__ + "static/img/MN.e5b21d34.png";